import { Link } from "react-router-dom";
import { Twitter, Instagram, MessagesSquare } from "lucide-react";
import { LogoMark } from "./Logo";

export default function Footer() {
  return (
    <footer className="border-t border-line bg-surface" data-testid="site-footer">
      <div className="mx-auto max-w-7xl px-5 py-14 lg:px-8">
        <div className="grid gap-10 md:grid-cols-4">
          <div className="md:col-span-1">
            <div className="flex items-center gap-2.5">
              <LogoMark size={28} />
              <span className="font-display font-800 tracking-tight text-white">
                FUNDED TRADERS <span className="text-gradient">CLUB</span>
              </span>
            </div>
            <p className="mt-4 text-sm leading-relaxed text-muted">
              The independent club for funded traders — verified firm ratings, exclusive
              discount codes, real member reviews and free trading tools.
            </p>
            <div className="mt-5 flex gap-3">
              {[
                { icon: MessagesSquare, label: "Discord", id: "discord", href: "https://discord.gg/a7899ShVPH" },
                { icon: Twitter, label: "X (Twitter)", id: "x", href: "https://x.com/kaitofxftc" },
                { icon: Instagram, label: "Instagram", id: "instagram", href: "https://www.instagram.com/kaitofx_ftc" },
              ].map((s) => (
                <a key={s.id} href={s.href} target="_blank" rel="noopener noreferrer" data-testid={`social-${s.id}`} title={s.label}
                  className="flex h-10 w-10 items-center justify-center rounded-full border border-line bg-elevate text-muted transition-all duration-200 hover:-translate-y-0.5 hover:border-signal/60 hover:text-signal">
                  <s.icon size={16} />
                </a>
              ))}
            </div>
          </div>
          <div>
            <p className="font-mono text-[10px] uppercase tracking-[0.25em] text-signal">Platform</p>
            <ul className="mt-4 space-y-2.5 text-sm text-muted">
              <li><Link to="/firms" className="transition-colors hover:text-white" data-testid="footer-firms-link">Browse Firms</Link></li>
              <li><Link to="/blog" className="transition-colors hover:text-white" data-testid="footer-blog-link">Trading Articles</Link></li>
              <li><Link to="/about" className="transition-colors hover:text-white" data-testid="footer-about-link">About Us</Link></li>
              <li><Link to="/auth" className="transition-colors hover:text-white" data-testid="footer-join-link">Join The Club</Link></li>
              <li><Link to="/admin/login" className="transition-colors hover:text-white" data-testid="footer-admin-link">Admin Access</Link></li>
            </ul>
          </div>
          <div>
            <p className="font-mono text-[10px] uppercase tracking-[0.25em] text-signal">Trading Tools</p>
            <ul className="mt-4 space-y-2.5 text-sm text-muted">
              <li><Link to="/journal" className="transition-colors hover:text-white" data-testid="footer-journal-link">Trading Journal</Link></li>
              <li><Link to="/tools/consistency" className="transition-colors hover:text-white" data-testid="footer-consistency-link">Consistency Calculator</Link></li>
            </ul>
          </div>
          <div>
            <p className="font-mono text-[10px] uppercase tracking-[0.25em] text-signal">Disclosure</p>
            <p className="mt-4 text-xs leading-relaxed text-muted">
              Funded Traders Club may earn a commission through referral links and discount codes.
              Editorial scores are calculated independently and are never influenced by
              partnerships.
            </p>
          </div>
        </div>
        <div className="mt-12 flex flex-col gap-3 border-t border-line pt-6 font-mono text-[10px] uppercase tracking-[0.2em] text-muted md:flex-row md:items-center md:justify-between">
          <span data-testid="footer-copy">© 2026 FUNDED TRADERS CLUB — TRADE THEIR CAPITAL</span>
          <span className="text-signal">SYSTEM STATUS: <span className="animate-blink">●</span> LIVE</span>
        </div>
      </div>
    </footer>
  );
}
